import request from '@/utils/request'

// 获取合作伙伴列表
export function getPublicPartners() {
  return request({ url: '/cms/partner/public/list', method: 'get' })
}

// 获取统计数据
export function getPublicPartnerStats() {
  return request({ url: '/cms/partner/stat/public/list', method: 'get' })
}

// 获取页面配置
export function getPublicPartnerConfigs() {
  return request({ url: '/cms/partner/config/public/list', method: 'get' })
}

// 获取应用领域列表
export function getPublicPartnerApplications() {
  return request({ url: '/cms/partner/application/public/list', method: 'get' })
}
